





























import { Component, Prop, Vue } from "vue-property-decorator";
import { FriendRef } from "@dokogd/shared";
import { api } from "../../store/modules/friends";
import { Getter } from "vuex-class";
import ItemRefList from "../controls/ItemRefList.vue";
@Component({ components: { ItemRefList } })
export default class FriendSelect extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  ignore!: string[];

  @Getter(api.getters.getFriends, { namespace: api.namespace })
  list!: FriendRef[];
}
